<template>
    <modal
        :saveAction="save"
        :title="$t(title)"
        :id="id"
        :deleteAction="manipulation._id ? manipulation.can_delete ? deleteAction : false : false"
        :actionButtons="!hideForm"
        size="large"
        :closeButton="hideForm"
        @shown="shown() "
    >
        <div class="row align-items-center mb-2">
            <div class="col">
                <b-form-group :label="$t('Label')">
                    <b-form-input v-model="manipulation.label" :placeholder="$t('Ex.: Anesthesia')"></b-form-input>
                </b-form-group>
            </div>

            <div class="col-2">
                <b-form-group :label="$t('Language')">
                    <b-form-select v-model="manipulation.language" :options="languages"></b-form-select>
                </b-form-group>
            </div>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { mapActions, mapGetters, mapState } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'


export default {
    name: 'manipulation-form-modal',
    props: ['id', 'saveAction', 'data'],
    mixins: [modalMixins],
    components: {
        Modal,
    },
    data() {
        return {
            loading: false,
            hideForm: false,
            languages: [
                { text: 'English', value: 'english' },
                { text: 'Russian', value: 'russian' },
            ],
            manipulation: {
                language: 'russian'
            },
            title: 'Manipulation',
        }
    },
    computed: {

    },
    mounted() {
        this.$root.$on('bv::hide::modal', (modal) => {
            this.hideForm = false;
        })

    },
    methods: {
        ...mapActions('manipulations', ['find', 'create', 'patch', 'remove']),

        save() {
            let promise, successMessage;
            if (this.manipulation._id) {
                promise = this.patch([this.manipulation._id, this.manipulation]);
                successMessage = this.$t('Item has been updated');
            } else {
                promise = this.create(this.manipulation);
                successMessage = this.$t('Item has been created');
            }


            promise.then(result => {
                this.$root.$emit('bv::hide::modal', this.id);
                this.$toasted.global.success({
                    message: successMessage
                });
            });
        },
        deleteAction() {

            this.remove(this.manipulation._id).then(result => {
                this.$toasted.global.success({
                    message: this.$t('Item has been removed')
                });
            });
        },

        shown() {
            /* Switch back to the first tab */
            this.manipulation = this.data;
        },
        validation(field) {
            if (this.errors && this.errors[field])
                return false
            else
                return null
        },


    },

}
</script>
<style>
.pre-formatted {
  white-space: pre;
}
</style>
